// extracted by mini-css-extract-plugin
export default {"wrapper":"toolbar_wrapper__41sa+","rightContent":"toolbar_rightContent__6oASf","noBackBtn":"toolbar_noBackBtn__tSeJG","backBtn":"toolbar_backBtn__xebkm"};